



















import { Component, Vue, Prop } from "vue-property-decorator";
import { Loader } from "../forms/parts";

@Component({
    components: {
        Loader
    }
})
export default class FaqBlock extends Vue {
    @Prop() title!: string;

    @Prop() items!: any;

    @Prop({ default: 50 }) perPage!: number;

    loading: boolean = false;

    params: any = { per_page: 50, page: 1 };

    faqs: any = [];

    faqIds: number[] = [];

    openItem: number | null = null;

    async mounted() {
        this.params.per_page = this.perPage;

        this.faqIds = this.items.map((item: any) => item.id);

        this.getFaqs(this.faqIds);
    }

    private async handleOpenItem(id: number) {
        if (this.openItem === id) {
            this.openItem = null;
            return;
        }

        this.openItem = id;
    }

    private async getFaqs(ids: number[]) {
        this.loading = true;

        // @ts-ignore
        return axios
            .get("/api/faq", { params: { ...this.params, include: ids } })
            .then((response: any) => {
                this.faqs = response.data.data;
            })
            .finally(() => (this.loading = false));
    }

    get openFaq() {
        return this.faqs.find((faq: any) => faq.id === this.openItem);
    }
}
